import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { fetchBlogs, getPageData, useData } from "../../app/helper/functions";
import PureCounter from "@srexi/purecounterjs";
import Heading from "../atoms/Heading/Heading";
import Footer from "../organisms/Footer/Footer";
import ContactHelp from "../molecules/ContactHelp/ContactHelp";

import { Blog } from "../../app/utlis/type";
import { useNavigate } from "react-router-dom";
import YELLOWARROW from "../../app/assets/images/yellow-arrow.svg";
import CRYONE from "../../app/assets/images/projectImage/cryoneimage/cryone.png";
import starr from "../../app/assets/images/aboutUsImages/starr.webp"; 
import bgImage from "../../app/assets/images/backgroundImages/portfolioherobg.webp";

const PortfolioPage = () => {
  const { data } = useData();
  const projectData = getPageData(data, "projects");
  const [key, setKey] = useState(0);
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("All");
  const [loading, setLoading] = useState(false);
  const [blogs, setBlogs] = useState<Blog[]>([]);
  const [filterBlogs, setFilterBlogs] = useState<Blog[]>([]);



  useEffect(() => {
    const interval = setInterval(() => {
      setKey((prevKey) => prevKey + 1);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    new PureCounter();
  }, []);

  useEffect(() => {
    if (activeTab === "All") {
      setFilterBlogs(blogs);
    } else {
      setFilterBlogs(
        blogs.filter((blog) => blog.categories.includes(activeTab))
      );
    }
  }, [activeTab]);

  useEffect(() => {
    try {
      setLoading(true);
      fetchBlogs().then((res) => {
        setBlogs(res);
        setFilterBlogs(res);
      });
    } catch (err) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }, []);

  // Animation variants for staggered children
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut",
      },
    },
  };

  const buttonVariants = {
    hover: { scale: 1.05 },
    tap: { scale: 0.95 },
  };

  const baseProjects = projectData?.ProjectsList || [];
  const hasCryone = baseProjects.some(
    (project: any) => String(project?.title || "").toLowerCase() === "cryone"
  );

  const portfolioProjects = hasCryone
    ? baseProjects
    : [
      ...baseProjects,
      {
        key: "cryone",
        title: "CRYONE",
        projectImage: CRYONE,
        projectNavigate: "/portfolio",
      },
    ];

  return (
    <div>
   <div
  className="min-h-[75vh] 2xl:min-h-[900px] bg-center bg-contain flex items-center"
  style={{ backgroundImage: `url(${bgImage})` }}
>
  <div className="w-full flex flex-col-reverse md:flex-row items-center justify-between px-8 md:px-16 lg:px-20 xl:px-20 2xl:px-[12%] py-12 md:pt-32 lg:pt-40">
    
    {/* Text */}
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className="w-full md:w-[55%] text-white text-center md:text-left"
    >
      <h1 className="text-4xl md:text-5xl xl:text-6xl font-bold leading-tight">
        Our Portfolio
      </h1>

      <p className="mt-4 text-base md:text-lg xl:text-xl 2xl:text-3xl text-white/70 leading-relaxed max-w-3xl mx-auto md:mx-0">
        Discover our collection of projects that highlight our expertise in web
        application development, mobile app development, custom software
        solutions, IT staff augmentation, and UI/UX design.
      </p>
    </motion.div>

    {/* Image */}
    <motion.div
      initial={{ opacity: 0, x: 50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className="w-[80%] max-w-[280px] md:w-[40%] md:max-w-[420px] mb-8 md:mb-0"
    >
      <img
        src={starr}
        alt="Portfolio"
        className="w-full object-contain"
      />
    </motion.div>

  </div>
</div>



      <div className="bg-newbgcolor">
        <div className="relative bg-blackDark">
          <motion.div
            data-aos="fade-up"
            className="animate-spin-slow"
            id="count-increment"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.1 }}
          >
            <div className="relative w-full flex flex-nowrap justify-between items-center px-2 md:px-8 py-6 md:py-10 border-y-[10px] border-blackDarkThemeSecondary text-center">
              {/* 1. Happy Clients */}
              <div className="flex flex-col items-center gap-1 md:gap-2 flex-1">
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ duration: 0.5 }}
                >
                  <div className="flex items-center justify-center">
                    <div
                      className="purecounter text-xl sm:text-2xl md:text-4xl font-bold"
                      data-purecounter-start="1"
                      data-purecounter-end="45"
                      data-purecounter-duration="2"
                    ></div>
                    <span className="text-xl sm:text-2xl md:text-4xl font-bold">
                      +
                    </span>
                  </div>
                </motion.div>
                <span className="text-xs sm:text-sm md:text-base font-medium mx-2 sm:mx-0">
                  Happy Clients
                </span>
              </div>

              {/* Yellow Circle */}
              <div className="w-6 h-6 sm:w-8 sm:h-8 md:w-14 md:h-14 bg-yellow rounded-full flex items-center justify-center z-10 mx-1 md:mx-2" >
                <div className="bg-white w-1.5 h-1.5 sm:w-2 sm:h-2 md:w-3 md:h-3 rounded-full" />
              </div>

              {/* 2. Projects Delivered */}
              <div className="flex flex-col items-center gap-1 md:gap-2 flex-1">
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ duration: 0.5 }}
                >
                  <div className="flex items-center justify-center">
                    <div
                      className="purecounter text-xl sm:text-2xl md:text-4xl font-bold"
                      data-purecounter-start="1"
                      data-purecounter-end="40"
                      data-purecounter-duration="2"
                    ></div>
                    <span className="text-xl sm:text-2xl md:text-4xl font-bold">
                      +
                    </span>
                  </div>
                </motion.div>
                <span className="text-xs sm:text-sm md:text-base font-medium">
                  Projects Delivered
                </span>
              </div>

              {/* Orange Circle */}
              <div className="w-6 h-6 sm:w-8 sm:h-8 md:w-14 md:h-14 orange-bg rounded-full flex items-center justify-center z-10 mx-1 md:mx-2" >
                <div className="bg-white w-1.5 h-1.5 sm:w-2 sm:h-2 md:w-3 md:h-3 rounded-full" />
              </div>

              {/* 3. Years of Service */}
              <div className="flex flex-col items-center gap-1 md:gap-2 flex-1">
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ duration: 0.5 }}
                >
                  <div className="flex items-center justify-center">
                    <div
                      className="purecounter text-xl sm:text-2xl md:text-4xl font-bold"
                      data-purecounter-start="1"
                      data-purecounter-end="8"
                      data-purecounter-duration="2"
                    ></div>
                    <span className="text-xl sm:text-2xl md:text-4xl font-bold">
                      +
                    </span>
                  </div>
                </motion.div>
                <span className="text-xs sm:text-sm md:text-base font-medium">
                  Years of service
                </span>
              </div>

              {/* Purple Circle */}
              <div className="w-6 h-6 sm:w-8 sm:h-8 md:w-14 md:h-14 bg-purple rounded-full flex items-center justify-center z-10 mx-1 md:mx-2" >
                <div className="bg-white w-1.5 h-1.5 sm:w-2 sm:h-2 md:w-3 md:h-3 rounded-full" />
              </div>

              {/* 4. Strong Team */}
              <div className="flex flex-col items-center gap-1 md:gap-2 flex-1">
                <div className="flex items-center justify-center">
                  <div
                    className="purecounter text-xl sm:text-2xl md:text-4xl font-bold"
                    data-purecounter-start="1"
                    data-purecounter-end="18"
                    data-purecounter-duration="2"
                  ></div>
                  <span className="text-xl sm:text-2xl md:text-4xl font-bold">
                    +
                  </span>
                </div>
                <span className="text-xs sm:text-sm md:text-base font-medium mx-2 sm:mx-0">
                  Strong Team
                </span>
              </div>
            </div>
          </motion.div>
        </div>
        <Heading subTitle="Our Projects on Display" className="pt-8" />

        <div className="grid grid-cols-2 gap-4 sm:gap-6 md:gap-10 lg:gap-14 px-2 sm:px-4 md:px-8 lg:px-16 xl:px-24 w-full lg:w-[90%] xl:w-[80%] justify-center items-center mx-auto pt-10">
          {portfolioProjects.map((project: any, index: number) => {
            return (
              <motion.div
                key={index}
                className="relative bg-darkGreyTernary overflow-hidden cursor-pointer opacity-50 hover:opacity-100 transition-all duration-700 ease-in-out group h-full sm:h-[300px] md:h-[400px] lg:h-[445px]"
                variants={itemVariants}
                whileHover={{
                  // scale: 1.02,
                  transition: { duration: 0.4, opacity: 1 },
                }}
              >
                <div className="w-full h-full overflow-hidden  opacity-50 hover:opacity-100 transition-all duration-700 ease-in-out">
                  <motion.img
                    src={project.projectImage}
                    className="w-full h-full object-contain object-center transform group-hover:scale-105 transition-transform duration-700"
                    onClick={() => {
                      navigate(project.projectNavigate);
                    }}
                    alt={project.title}
                    whileHover={{ scale: 1.05 }}
                    transition={{ duration: 0.7, ease: "easeOut" }}
                  />
                </div>
                <div className="absolute bottom-0 px-2 sm:px-4 w-full bg-blackBlur5">
                  <div className="flex justify-between items-center py-2 sm:py-3 md:py-5">
                    <motion.div
                      className="text-lg sm:text-xl md:text-2xl lg:text-4xl font-medium cursor-pointer truncate pr-2"
                      initial={{ x: -20, opacity: 0 }}
                      animate={{ x: 0, opacity: 1 }}
                      transition={{ duration: 0.5, delay: 0.2 }}
                    >
                      {project.title}
                    </motion.div>
                    <div className="flex justify-end gap-2 sm:gap-3 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                      <motion.img
                        src={YELLOWARROW}
                        className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6"
                        alt="arrow"
                        initial={{ x: 10 }}
                        animate={{ x: 0 }}
                        whileHover={{
                          x: 5,
                          transition: {
                            repeat: Infinity,
                            repeatType: "reverse",
                            duration: 0.5,
                          },
                        }}
                      />
                    </div>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
        <ContactHelp
          title="Let's connect & achieve your business goals together"
          buttonTitle="CONTACT US"
        />
        <Footer />
      </div>
    </div>
  );
};

export default PortfolioPage;
